export const notification = {
  notification: 'Njoftime',
  allNotifications: 'Të gjitha njoftimet',
  general: 'Përgjithshme',
  settings: 'Rregullime',
  newChatRequest: {
    youHaveANewChatRequest: 'Keni një kërkesë të re për bisedë!',
    youHaveTransferredChatRequest: 'Keni transferuar kërkesën e bisedës!',
    acceptRequest: 'Prano Kërkesën',
    discardRequest: 'Hidh Poshtë Kërkesën'
  },
  notificationList: {
    name: 'Emri',
    message: 'Mesazhi',
    noDataFound: {
      notification: 'Njoftim',
      noNotificationsFound: 'Nuk u gjetën njoftime!',
    }
  },
  notificationSetting: {
    userMessage: 'Mesazhi i Përdoruesit',
    receiveNotificationsWhenUserSendMessage: 'Merrni njoftime kur një përdorues dërgon ndonjë mesazh',
    liveChatRequest: 'Kërkesa për Bisedë të Drejtpërdrejtë',
    receiveNotificationsWhenUserRequestLiveChat: 'Merrni njoftime kur një përdorues kërkon bisedë të drejtpërdrejtë',
    newLead: 'Leadi i Ri',
    receiveNotificationsWhenNewLeadCreated: 'Merrni njoftime kur krijohen leade të reja',
    assignedOnly: 'Vetëm të Caktuarit',
    allUsers: 'Të Gjithë Përdoruesit',
    customizeWhichNotificationsYouWantToRecieve: 'Rregullo cilat njoftime dëshironi të merrni',
    youCanCustomizeSettingForTheNotifications: 'Mund të rregulloni parametrat për njoftimet',
    receiveNotifications: 'Merrni Njoftimet',
    desktopNotifications: 'Njoftime në Desktop',
    mobilePushNotifications: 'Njoftime me shtypje në celular',
    discard: 'Hidh Poshtë',
    update: 'Përditëso',
    appTooltip: {
      TOOLTIP_NEW_MESSAGE_DESKTOP_NOTIFICATION: 'Dërgo njoftimet e Mesazhit të Ri në Desktop',
      TOOLTIP_NEW_MESSAGE_MOBILE_NOTIFICATION: 'Dërgo njoftimet e Mesazhit të Ri në celular',
      TOOLTIP_NEW_LEAD_DESKTOP_NOTIFICATION: 'Dërgo njoftimet e Leadi të Ri në Desktop',
      TOOLTIP_NEW_LEAD_MOBILE_NOTIFICATION: 'Dërgo njoftimet e Leadi të Ri në celular',
      TOOLTIP_LIVE_CHAT_DESKTOP_NOTIFICATION: 'Dërgo njoftimet e Bisedës së Drejtpërdrejtë në Desktop',
      TOOLTIP_LIVE_CHAT_MOBILE_NOTIFICATION: 'Dërgo njoftimet e Bisedës së Drejtpërdrejtë në celular',
      TOOLTIP_RECEIVED_NOTIFICATION: 'Zgjidh cilat mesazhe dëshiron të njoftohesh për to'
    }
  }
};
